import * as Sentry from "@sentry/browser";
import { User, StripeSubscription } from "../docuclipper/DocuclipperTypes";

export const setSentryUserContext = (user: User | null) => {
    if (process.env.NODE_ENV !== "production") return;

    if (!user) {
        Sentry.setUser(null);
        return;
    }

    Sentry.setUser({
        id: user.id?.toString(),
        email: user.email,
    });
};

export const setSentrySubscriptionTags = (subscription: StripeSubscription | null) => {
    if (process.env.NODE_ENV !== "production") return;

    Sentry.setTag("subscription.status", subscription?.status || "none");


};

export const clearSentryContext = () => {
    if (process.env.NODE_ENV !== "production") return;
    Sentry.setUser(null);
};
